import { Column, ConsentFileAnalysedStatus, RAGStatus, ColumnType, ConsentFileType } from '../types';
import { TFunction } from 'react-i18next';
import { buildConsentCsv } from './ConsentCsvBuilder';

export const makeRedStatus = (
  t: TFunction<'fileManagement'>,
  errors: string[],
  consentType: ConsentFileType,
): ConsentFileAnalysedStatus => {
  return {
    type: RAGStatus.RED,
    message: t('analysis.file.analysed.red.text'),
    errors: errors,
    consentType,
  };
};

export const makeAmberStatus = (
  t: TFunction<'fileManagement'>,
  columns: Column[],
  consentType: ConsentFileType,
): ConsentFileAnalysedStatus => ({
  type: RAGStatus.AMBER,
  message: t('analysis.file.analysed.amber.text'),
  columns: columns,
  consentType,
});

export const makeGreenStatus = (
  t: TFunction<'fileManagement'>,
  columns: Column[],
  consentType: ConsentFileType,
): ConsentFileAnalysedStatus => {
  const emailColumn = columns.find(col => col.type === ColumnType.EMAIL);
  const dateColumn = columns.find(col => col.type === ColumnType.DATE) ?? {
    type: ColumnType.DATE,
    heading: 'EffectiveDate',
    rows: [],
  };

  return {
    type: RAGStatus.GREEN,
    message: t('analysis.file.analysed.green.text'),
    fileData: buildConsentCsv(emailColumn, dateColumn, t),
    emailCount: emailColumn.rows.length,
    consentType,
  };
};
